import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modals/deposit_success';

import Cash from './cash';
import TestYourLuck from './testyourluck';
import FreePlay from './freeplay';

export default () => {
    const {type} = useSelector(Selector);

    if(type === 'cash') return <Cash />
    if(type === 'testyourluck') return <TestYourLuck />
    if(type === 'freeplay') return <FreePlay />
    return <></>;
}